import styled from "styled-components";
import {
    Sidebar,
    SidebarFooter,
    SidebarGroup,
    SidebarHeader,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar";
import { ColorTheme, TextTheme } from "@/components/globaStyledComponents/globalStyledComponentsStyling";
import { BorderRadiusTheme } from "@/components/globaStyledComponents/globalStyledComponentsStyling";

export const DashboardSidebarHeader = styled(SidebarHeader)`
    padding: 12px;
    display: flex;
    flex-direction: row;
`;

export const AnystaySidebarLogoBtn = styled.div`
    padding: 12px 8px;
    cursor: pointer;
    transition: background-color 0.3s;
    user-select: none;
`;

export const DashBoardSidebar = styled(Sidebar)`
    width: 220px;
    border: none;
`;

export const DashBoardSidebarGroup = styled(SidebarGroup)`
    padding: 0 12px;
`;

export const DashBoardSidebarMenuItem = styled(SidebarMenuItem)`
    height: 48px;
    border-radius: 8px;
`;

export const DashboardSidebarMenuButton = styled(SidebarMenuButton)<{ selected: boolean }>`
    height: 48px;
    transition: background-color 0.1s;
    gap: 12px;
    color: ${(props) => props.selected ? '#222' : '#737373'};
    border-radius: 12px;

    &:hover {
        background-color: #eeeae6;
    }
`;

export const DashboardSidebarMenuButtonText = styled.div`
    color: inherit;
    font-size: ${TextTheme.sans_350_semi.fontSize};
    line-height: ${TextTheme.sans_350_semi.lineHeight};
    font-family: ${TextTheme.sans_350_semi.fontFamily};
`;

export const SidebarMenuButtonIconContainer = styled.div`
    padding: 6px;
`;

export const DashboardSidebarFooter = styled(SidebarFooter)`
    padding: 12px;
`;

export const InviteFriendsCard = styled.div`
    margin: 0 4px;
    padding: 16px;
    background-color: ${ColorTheme.Grey5.color};
    border-radius: ${BorderRadiusTheme.radius_12.borderRadius};
    cursor: pointer;
    transition: all 0.2s ease;
    opacity: 0;
    transform: translateY(10px);
    animation: fadeIn 0.2s ease 0.3s forwards;
    margin-top: 24px;

    &:hover {
        background-color: #eeeae6;
    }

    .group[data-collapsible="icon"] & {
        display: none;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

export const InviteFriendsTitle = styled.div`
    font-size: ${TextTheme.sans_300_semi.fontSize};
    line-height: ${TextTheme.sans_300_semi.lineHeight};
    font-family: ${TextTheme.sans_300_semi.fontFamily};
    color: ${ColorTheme.Black.color};
    margin-bottom: 4px;
`;

export const InviteFriendsSubtitle = styled.div`
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    font-family: ${TextTheme.sans_300.fontFamily};
    color: ${ColorTheme.Grey.color};
`;
